import * as React from 'react';
import { QuestionDto } from '../../../../pages/questionTypes';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AnswerDto, getEmptyAnswerDto } from '../../../../pages/answerTypes';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { ColumnDto } from '../../../../pages/columnTypes';
import OnFinishedTextField from '../../../OnFinishedTextField';
import { ColumnAnswerDto } from '../../../../pages/columnAnswerTypes';
import { Grid } from '@material-ui/core';

interface Props {
  question: QuestionDto,
  existingAnswer?: AnswerDto,
  saveAnswer: (answer: AnswerDto) => void
}

type LocalStyles = 'textField';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  textField: {
    paddingRight: theme.spacing.unit * 2
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class MultipleColumnQuestion extends React.Component<PropsWithStyle> {

  @observable private answer: AnswerDto = getEmptyAnswerDto();

  constructor(props: PropsWithStyle) {
    super(props);
    this.answer.question = this.props.question;
    if (this.props.existingAnswer !== undefined) {
      this.answer = this.props.existingAnswer
    }
  }

  public render() {
    return (
      <>
        {
          this.props.question.columns &&
          this.props.question.columns.map(column => (
            <Grid key={this.props.question.id.toString() + column.id.toString()}
                  item={true} sm={12} md={true}>
              <OnFinishedTextField
                className={this.props.classes.textField}
                id={column.id.toString()}
                label={column.title}
                fullWidth={true}
                onFinished={(value: string) => this.handleTextChange(value, column)}
                value={this.getAnswerForColumn(column)}
                multiline={true}/>
            </Grid>
          ))
        }
      </>
    )
  }

  private getAnswerForColumn = (column: ColumnDto): string => {
    if (this.props.existingAnswer === undefined || this.props.existingAnswer.columnAnswers === undefined) {
      return ''
    } else {
      const existingAnsweredColumn = this.props.existingAnswer.columnAnswers.find((existingColumn: ColumnAnswerDto) => {
        return existingColumn.column.id === column.id
      });
      if (existingAnsweredColumn === undefined) {
        return '';
      } else {
        return existingAnsweredColumn.answer
      }
    }
  };

  private handleTextChange = (value: string, givenColumn: ColumnDto) => {
    const answerString = value;
    if (this.answer.columnAnswers === undefined) {
      this.answer.columnAnswers = [];
      this.answer.columnAnswers.push({answer: answerString, column: givenColumn})
    } else {
      const answeredColumn = this.answer.columnAnswers.find((existingColumn) => {
        return existingColumn.column.id === givenColumn.id
      });
      if (answeredColumn === undefined) {
        this.answer.columnAnswers.push({answer: answerString, column: givenColumn})
      } else {
        const index = this.answer.columnAnswers.indexOf(answeredColumn);
        this.answer.columnAnswers[index].answer = answerString;
      }
    }

    this.props.saveAnswer(this.answer);
  };
}

export default withStyles(localStyles)(MultipleColumnQuestion);

